import { render, staticRenderFns } from "./Socio-pagamento.vue?vue&type=template&id=3bc241d1"
import script from "./Socio-pagamento.vue?vue&type=script&lang=js"
export * from "./Socio-pagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports